<template>
  <div class="dialog">
    <!-- 预约弹窗主体 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="currentVisible"
      width="700px"
      @close="handleClose"
      :before-close="handleBeforeClose"
      v-loading="loading"
      element-loading-text="加载中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.2)"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      custom-class="custom-dialog"
    >
      <!-- 表单区域 -->
      <el-form :model="form" label-width="100px" ref="formRef" :rules="formRules" label-position="left">
        <!-- 1. 预约人（带性别头像+点击跳转） -->
        <el-form-item label="承约人">
          <div class="user-info" @click="handleUserDetail" :style="{cursor: 'pointer'}">
            <!-- 用户头像 -->
            <img class="avatar" :src="form.headPicUrl || ''" alt="用户头像" />
            <!-- 性别标识 -->
            <img class="gender-icon" src="/img/hed.png" alt="女性" v-if="form.gender === 0" />
            <img class="gender-icon" src="/img/man.png" alt="男性" v-else-if="form.gender === 1" />
            <!-- 用户昵称 -->
            <span class="nickname">{{ form.nickName || '未登录用户' }}</span>
          </div>
        </el-form-item>

        <!-- 2. 咨询类型（控制问题描述显示） -->
        <el-form-item label="咨询类型" prop="type">
          <el-select v-model="form.type" placeholder="请选择咨询类型" @change="handleTypeChange">
            <el-option label="随便聊聊" value="casual" />
            <el-option label="交流些技术（或业务）" value="tech" />
            <el-option label="请教些知识" value="knowledge" />
            <el-option label="求帮解决问题" value="problem" />
          </el-select>
        </el-form-item>

        <!-- 3. 问题描述（动态显示+字数限制） -->
        <el-form-item label="问题描述" prop="consultDescription" v-if="showDescInput">
          <el-input
            v-model="form.consultDescription"
            type="textarea"
            placeholder="请详细描述问题"
            :maxlength="200"
            show-word-limit
            rows="3"
          />
        </el-form-item>

        <!-- 4. 开始时间（日期+时间联动） -->
        <el-form-item label="开始时间" prop="date" class="date-time-form-item">
          <!-- 日期选择器 -->
          <el-date-picker
            v-model="form.date"
            type="date"
            placeholder="选择日期"
            style="width: 300px"
            :disabled-date="disabledDate"
            @change="handleDateChange"
          />
          <el-form-item label="" prop="time" class="time-select">
            <el-select v-model="form.time" placeholder="选择时间" style="width: 270px; margin-left: 10%" prop="time">
              <el-option v-for="(time, index) in timeOptions" :key="index" :label="time" :value="time" />
            </el-select>
          </el-form-item>
          <!-- 时间选择器（动态选项） -->
          <!-- 预约冲突提示 -->
          <div class="conflict-tip" v-if="conflictTip">{{ conflictTip }}</div>
        </el-form-item>

        <!-- 5. 咨询时长（扩展选项+默认1小时） -->
        <el-form-item label="咨询时长" prop="duration">
          <el-select v-model="form.duration" placeholder="请选择时长" @change="calculatePrice">
            <el-option v-for="hour in durationOptions" :key="hour.value" :label="hour.label" :value="hour.value" />
          </el-select>
        </el-form-item>

        <!-- 6. 咨询人数（扩展选项+默认1人） -->
        <el-form-item label="咨询人数" prop="people">
          <el-select v-model="form.people" placeholder="请选择人数" @change="calculatePrice">
            <el-option v-for="(item, index) in peopleOptions" :key="index" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>

        <!-- 7. 价格（动态计算+禁用输入） -->
        <el-form-item label="价格:">
          <div class="price">
            {{ form.price }}
          </div>
          <!-- <el-input v-model="form.price" placeholder="计算中..." disabled /> -->
          <!-- 价格构成提示 -->
          <!-- <div class="price-tip" v-if="form.price && form.price !== '计算中...'">
            价格构成：{{ form.finalUnitPrice }}元/小时 × {{ form.duration }}小时 × {{ getPeopleCoeff() }}倍人数系数
          </div> -->
        </el-form-item>

        <!-- 8. 交流方式（固定值） -->
        <el-form-item label="交流方式:">
          <div class="method">
            {{ form.method }}
          </div>
          <!-- <el-input v-model="form.method" placeholder="实时视频，可共享屏幕" disabled /> -->
        </el-form-item>
      </el-form>

      <!-- 弹窗底部按钮 -->
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm" :loading="submitLoading" class="submit-btn">预约</el-button>
      </div>
    </el-dialog>

    <!-- 9. 关注列表弹窗 -->
    <!-- <el-dialog title="我的关注 ({{ followList.length }})" :visible.sync="followDialogVisible" width="400px">
      <div class="list-container" v-if="followList.length">
        <div class="list-item" v-for="(item, index) in followList" :key="index">
          <div class="user-info" @click="handleFollowFilter(item)" :style="{cursor: 'pointer'}">
            <img class="avatar" :src="item.headPicUrl || defaultAvatar" alt="用户头像" />
            <img class="gender-icon" src="/img/hed.png" alt="女性" v-if="item.gender === 1" />
            <img class="gender-icon" src="/img/man.png" alt="男性" v-else-if="item.gender === 2" />
            <span class="nickname">{{ item.nickName }}</span>
          </div>
          <el-button type="text" class="delete-btn" @click="handleUnfollow(item.id)">
            取消关注
          </el-button>
        </div>
      </div>
      <div class="empty-tip" v-else>暂无关注用户</div>
    </el-dialog> -->

    <!-- 10. 粉丝列表弹窗 -->
    <!-- <el-dialog title="我的粉丝 ({{ fanList.length }})" :visible.sync="fanDialogVisible" width="400px">
      <div class="list-container" v-if="fanList.length">
        <div class="list-item" v-for="(item, index) in fanList" :key="index">
          <div class="user-info">
            <img class="avatar" :src="item.headPicUrl || defaultAvatar" alt="用户头像" />
            <span class="nickname">{{ formatPhone(item.phone) }}</span>
          </div>
          <el-button type="text" class="delete-btn" @click="handleRemoveFan(item.id)">
            移除粉丝
          </el-button>
        </div>
      </div>
      <div class="empty-tip" v-else>暂无粉丝</div>
    </el-dialog> -->
  </div>
</template>

<script>
import {
  getAppointmentDesc,
  checkUserStatus,
  getReserveConflicts,
  getFollowList,
  getFanList,
  unfollowUser,
  removeFan,
  postAppointment
} from '../../api/counsult'
import {isWorkday} from 'chinese-days' // 第三方节假日判断库
// import defaultAvatar from '../../assets/default-avatar.png' // 默认头像

export default {
  name: 'AppointmentDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    consultantId: {
      type: Number,
      default: 0
    },
    // 接收关注/粉丝列表显示控制（从父组件传入）
    showFollowDialog: {
      type: Boolean,
      default: false
    },
    showFanDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 弹窗控制
      currentVisible: this.visible,
      followDialogVisible: this.showFollowDialog,
      fanDialogVisible: this.showFanDialog,

      // Loading状态
      loading: false, // 弹窗整体loading状态
      submitLoading: false, // 提交按钮loading状态

      // 表单数据
      form: {
        consultantId: this.consultantId,
        employeeId: 0,
        gender: 0, // 1-女 2-男
        headPicUrl: '',
        nickName: '',
        phone: '', // 粉丝手机号（用于脱敏显示）
        type: '', // 咨询类型(casual/tech/knowledge/problem)
        consultDescription: '', // 咨询问题描述
        date: null, // 预约日期
        time: '', // 预约时间
        duration: '1', // 咨询时长（小时）
        people: '我1人', // 咨询人数
        price: '', // 最终价格
        method: '实时视频，可共享屏幕',
        originalPrice: 0, // 被预约人原价（元/小时）
        discountPrice: 0, // 被预约人优惠价（元/小时）
        hasDiscount: false, // 是否有优惠
        priceConfigs: [], // 价格系数配置（接口返回）- 咨询人数系数
        consultTypeConfigs: [], // 咨询类型价格系数配置（接口返回）
        finalUnitPrice: 0, // 最终单价（优惠价与活动价取低）
        // 咨询类型映射关系：前端值 -> 后端所需的数字类型
        typeMap: {
          casual: 1, // 随便聊聊
          tech: 2, // 交流些技术(或业务)
          knowledge: 3, // 请教些知识
          problem: 4 // 求帮解决问题
        },
        // 人数映射：前端显示文本 -> 后端所需的数字
        peopleNumMap: {
          我1人: 1,
          '2人': 2,
          '3人': 3,
          '4人': 4,
          '5人': 5,
          '6人': 6,
          '7人': 7,
          '8人': 8,
          '10人': 10,
          '12人': 12,
          '15人': 15,
          '20人': 20,
          '25人': 25,
          '30人': 30,
          '40人': 40,
          '50人': 50,
          '60人': 60,
          '80人': 80,
          '100人': 100
        },
        advanceTime: {
          // 各类型提前预约时间（可配置）
          casual: 1, // 随便聊聊-1小时
          tech: 2, // 技术交流-2小时
          knowledge: 4, // 请教知识-4小时
          problem: 8 // 解决问题-8小时
        }
      },

      // 咨询时长选项 - 优化后的配置
      durationOptions: (() => {
        const hours = [0.5, 1, 1.5, 2, 2.5, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
        return hours.map(hour => ({
          label: `${hour}小时`,
          value: hour.toString()
        }))
      })(),
      // 咨询人数选项，
      peopleOptions: [
        // 咨询人数选项
        {
          label: '我1人',
          value: '1'
        },
        {
          label: '2人',
          value: '2'
        },
        {
          label: '3人',
          value: '3'
        },
        {
          label: '4人',
          value: '4'
        },
        {
          label: '5人',
          value: '5'
        },
        {
          label: '6人',
          value: '6'
        },
        {
          label: '7人',
          value: '7'
        },
        {
          label: '8人',
          value: '8'
        },
        {
          label: '10人',
          value: '10'
        },
        {
          label: '12人',
          value: '12'
        },
        {
          label: '15人',
          value: '15'
        },
        {
          label: '20人',
          value: '20'
        },
        {
          label: '25人',
          value: '25'
        },
        {
          label: '30人',
          value: '30'
        },
        {
          label: '40人',
          value: '40'
        },
        {
          label: '50人',
          value: '50'
        },
        {
          label: '60人',
          value: '60'
        },
        {
          label: '80人',
          value: '80'
        },
        {
          label: '100人',
          value: '100'
        }
      ],
      timeOptions: [], // 动态时间选项（根据日期生成）

      // 状态控制
      showDescInput: false, // 是否显示问题描述
      conflictTip: '', // 预约冲突提示
      formRules: {
        // 表单校验规则
        type: [{required: true, message: '请选择咨询类型', trigger: 'change'}],
        time: [{required: true, message: '请选择预约时间', trigger: 'change'}],
        duration: [{required: true, message: '请选择咨询时长', trigger: 'change'}],
        people: [{required: true, message: '请选择咨询人数', trigger: 'change'}],
        consultDescription: [
          {required: true, message: '请输入问题描述', trigger: 'blur'},
          {max: 200, message: '描述不能超过200字', trigger: 'blur'}
        ],
        date: [{required: true, message: '请选择预约日期', trigger: 'change'}]
      },

      // 列表数据
      followList: [], // 关注列表
      fanList: [] // 粉丝列表
      // defaultAvatar: defaultAvatar // 默认头像
    }
  },
  computed: {
    // 弹层标题（带图标）
    dialogTitle() {
      return '预约咨询'
    }
  },
  watch: {
    // 同步外部显示状态
    visible(newVal) {
      this.currentVisible = newVal
      if (newVal) this.initAppointData()
    },
    currentVisible(newVal) {
      if (newVal !== this.visible) this.$emit('update:visible', newVal)
    },
    // 同步关注/粉丝弹窗显示
    showFollowDialog(newVal) {
      this.followDialogVisible = newVal
      if (newVal) this.getFollowList()
    },
    showFanDialog(newVal) {
      this.fanDialogVisible = newVal
      if (newVal) this.getFanList()
    }
  },
  methods: {
    /**
     * 初始化预约数据：适配新接口返回格式
     */
    async initAppointData() {
      this.loading = true
      try {
        const res = await getAppointmentDesc({consultantId: this.consultantId})

        // 校验接口状态（新接口code=1为成功）
        if (res.code !== 200) {
          throw new Error(res.msg || '获取预约信息失败')
        }

        const apiData = res.data
        // 字段映射：适配新接口结构
        this.form = {
          ...this.form,
          consultantId: apiData.consultantId || this.consultantId,
          gender: apiData.gender || 0,
          headPicUrl: apiData.headPicUrl || this.defaultAvatar,
          nickName: apiData.nickName || '未命名用户',
          originalPrice: this.formatPriceToNumber(apiData.originalPrice),
          discountPrice: this.formatPriceToNumber(apiData.discountPrice),
          hasDiscount: apiData.hasDiscount || false,
          priceConfigs: apiData.priceConfigs || [],
          consultTypeConfigs: apiData.consultTypeConfigs,
          employeeId: apiData.employeeId || 0
        }

        // 计算最终单价（有优惠用优惠价，无优惠用原价）
        this.form.finalUnitPrice = this.form.hasDiscount ? this.form.discountPrice : this.form.originalPrice

        // 初始化价格
        this.calculatePrice()
      } catch (err) {
        console.error('初始化预约数据失败：', err)
        // this.$message.error(err.message || '加载预约信息失败，请重试')
      } finally {
        this.loading = false
      }
    },

    /**
     * 价格格式化工具：处理接口返回的字符串价格
     */
    formatPriceToNumber(price) {
      if (typeof price === 'number') return price
      if (typeof price !== 'string') return 0

      // 提取数字（支持"¥200.00"、"200元"、"200.5"等格式）
      const numberStr = price.replace(/[^\d.]/g, '')
      return numberStr ? parseFloat(numberStr) : 0
    },

    /**
     * 获取默认咨询类型配置
     */
    getDefaultConsultTypeConfigs() {
      return [
        {key: '1', value: '0.95'}, // 随便聊聊
        {key: '2', value: '1'}, // 交流些技术 (或业务)
        {key: '3', value: '1.05'}, // 请教些知识
        {key: '4', value: '1.1'} // 求帮解决问题
      ]
    },

    /**
     * 计算最终价格：从接口priceConfigs获取人数系数，从consultTypeConfigs获取咨询类型系数
     */
    calculatePrice() {
      // 校验必要参数
      if (!this.form.finalUnitPrice || !this.form.duration || !this.form.people) {
        this.form.price = '计算中...'
        return
      }

      // 从接口priceConfigs获取当前人数的系数
      const peopleKey = this.form.people
      const targetPeopleConfig = this.form.priceConfigs.find(item => item.key == peopleKey)
      // 系数默认值：未找到配置时用1
      const peopleCoeff = targetPeopleConfig ? parseFloat(targetPeopleConfig.value) : 1

      // 从接口consultTypeConfigs获取当前咨询类型的系数
      let consultTypeCoeff = 1
      if (this.form.type) {
        // 将前端类型值转换为后端数字类型
        const consultTypeNum = this.form.typeMap[this.form.type]
        if (consultTypeNum) {
          const targetTypeConfig = this.form.consultTypeConfigs.find(item => item.key == consultTypeNum.toString())
          consultTypeCoeff = targetTypeConfig ? parseFloat(targetTypeConfig.value) : 1
        }
      }

      // 计算价格（时长转数字，保留2位小数）
      // 价格 = 单价 × 时长 × 人数系数 × 咨询类型系数
      const duration = parseFloat(this.form.duration)
      const totalPrice = this.form.finalUnitPrice * duration * peopleCoeff * consultTypeCoeff

      this.form.price = `¥ ${totalPrice.toFixed(2)}`
    },

    /**
     * 获取当前人数系数（用于价格构成显示）
     */
    getPeopleCoeff() {
      const peopleKey = this.form.people
      const targetConfig = this.form.priceConfigs.find(item => item.key === peopleKey)
      return targetConfig ? parseFloat(targetConfig.value) : 1
    },

    /**
     * 咨询类型变更（控制问题描述显示+重新计算价格）
     */
    handleTypeChange(type) {
      this.showDescInput = ['knowledge', 'problem'].includes(type)
      this.$refs.formRef && this.$refs.formRef.clearValidate('consultDescription')
      // 咨询类型改变时重新计算价格
      this.calculatePrice()
    },

    /**
     * 日期变更（生成对应时间选项+判断工作日）
     */
    handleDateChange(date) {
      if (!date) return
      this.form.time = ''
      this.conflictTip = ''

      // 判断是否为工作日
      const isWork = isWorkday(date)

      // 生成时间选项
      this.generateTimeOptions(isWork)

      // 校验预约时间是否有效
      // this.checkReserveTimeValid()
      // 检查预约冲突
      // this.checkReserveConflict()
    },

    /**
     * 生成时间选项（工作日19:00-23:00，节假日9:00-23:00）
     */
    generateTimeOptions(isWork) {
      const timeOptions = []
      // 起始时间：工作日19:00，节假日9:00
      const startHour = isWork ? 19 : 9

      // 生成半小时间隔的时间选项
      for (let hour = startHour; hour < 23; hour++) {
        const formattedHour = hour.toString().padStart(2, '0')
        timeOptions.push(`${formattedHour}:00`)
        timeOptions.push(`${formattedHour}:30`)
      }
      // 补充23:00选项
      timeOptions.push('23:00')

      this.timeOptions = timeOptions
    },

    /**
     * 禁用过去的日期
     */
    disabledDate(time) {
      return time.getTime() < Date.now() - 8.64e7 // 只能选择今天及以后的日期
    },

    /**
     * 检查预约时间是否有效（不早于当前时间）
     */
    checkReserveTimeValid() {
      if (!this.form.date || !this.form.time) return true

      const [hours, minutes] = this.form.time.split(':').map(Number)
      const reserveTime = new Date(this.form.date)
      reserveTime.setHours(hours, minutes, 0, 0)

      // 预约时间必须晚于当前时间
      return reserveTime.getTime() > Date.now()
    },

    /**
     * 检查预约冲突
     */
    async checkReserveConflict() {
      try {
        if (!this.form.date || !this.form.consultantId) return

        // 调用冲突检查接口
        const res = await getReserveConflicts({
          consultantId: this.form.consultantId,
          reserveDate: this.form.date
        })

        if (res.code === 1 && res.data && res.data.length > 0) {
          this.handleConflictData(res.data)
        } else {
          this.conflictTip = ''
        }
      } catch (err) {
        console.error('检查预约冲突失败：', err)
        this.conflictTip = '冲突检查失败，请刷新重试'
      }
    },

    /**
     * 处理冲突数据
     */
    handleConflictData(conflicts) {
      // 简单处理：取第一个冲突作为提示
      if (conflicts.length > 0) {
        const firstConflict = conflicts[0]
        if (firstConflict.type === 'consultant') {
          this.conflictTip = `${this.form.nickName}已有结束时间为${firstConflict.endTime}的预约存在，新预约需不早于${firstConflict.nextAvailableTime}`
        } else {
          this.conflictTip = `您已有开始时间为${firstConflict.startTime}的预约存在，新预约结束时间应不晚于${firstConflict.latestEndTime}`
        }
      }
    },

    /**
     * 检查用户状态（是否被禁止预约）
     */
    async checkUserStatus() {
      try {
        const res = await checkUserStatus()
        if (res.code === 1) {
          const data = res.data
          if (data.forbidden) {
            return {
              valid: false,
              msg: data.forbiddenUntil ? `您的帐号已被禁止预约，恢复时间${data.forbiddenUntil}` : '您的帐号已被禁止预约'
            }
          }
          return {valid: true}
        }
        return {valid: false, msg: '检查用户状态失败'}
      } catch (err) {
        console.error('检查用户状态失败：', err)
        return {valid: false, msg: '检查用户状态失败，请重试'}
      }
    },

    /**
     * 检查提前预约时间是否足够
     */
    checkAdvanceTime() {
      if (!this.form.type || !this.form.date || !this.form.time) return false

      const requiredHours = this.form.advanceTime[this.form.type] || 1
      const [hours, minutes] = this.form.time.split(':').map(Number)
      const reserveTime = new Date(this.form.date)
      reserveTime.setHours(hours, minutes, 0, 0)

      // 计算当前时间到预约时间的小时差
      const timeDiff = (reserveTime.getTime() - Date.now()) / (1000 * 60 * 60)

      if (timeDiff < requiredHours) {
        const typeTextMap = {
          casual: '随便聊聊',
          tech: '交流些技术（或业务）',
          knowledge: '请教些知识',
          problem: '求帮解决问题'
        }
        const typeText = typeTextMap[this.form.type] || '该类型'
        this.$message.warning(`${typeText} 类型的预约，现在距预约开始时间应不小于 ${requiredHours} 小时`)
        return false
      }
      return true
    },

    /**
     * 提交表单（核心优化：适配新POST参数）
     */
    async submitForm() {
      this.$refs.formRef.validate(async isValid => {
        if (!isValid) return

        // // 检查用户状态
        // const userStatus = await this.checkUserStatus()
        // if (!userStatus.valid) {
        //   this.$message.error(userStatus.msg)
        //   return
        // }

        // // 检查提前预约时间
        // const advanceValid = this.checkAdvanceTime()
        // if (!advanceValid) return

        // 检查预约时间有效性
        // if (!this.checkReserveTimeValid()) {
        //   this.$message.warning('预约时间不能早于当前时间')
        //   return
        // }

        this.submitLoading = true
        try {
          // 1. 处理开始时间格式：拼接日期和时间为"YYYY-MM-DD HH:mm:ss"
          const dateStr = this.formatDate(this.form.date)
          const startTime = `${dateStr} ${this.form.time}:00`

          // 2. 转换咨询时长为分钟
          const durationHours = parseFloat(this.form.duration)
          const consultDuration = Math.round(durationHours * 60)

          // 3. 获取咨询类型对应的数字编码
          const consultType = this.form.typeMap[this.form.type] || 1
          // 4. 获取咨询人数对应的数字
          const consulterNum = +this.form.people || 1

          // 构建符合要求的POST参数
          const submitData = {
            consultantId: this.form.consultantId, // 受询人id
            consultType: consultType, // 咨询类型（数字）
            consultDescription: this.form.consultDescription, // 咨询问题描述
            startTime: startTime, // 开始时间（格式化字符串）
            consultDuration: consultDuration, // 预约时长(分钟)
            consulterNum: consulterNum // 咨询人数
          }

          const res = await postAppointment(submitData)
          if (res.code === 200) {
            this.$router.push({
              path: '/pay',
              query: {
                orderId: res.data
              }
            })
            // this.$message.success('预约成功！即将跳转支付页')
            this.handleClose()
            this.resetForm()
            // window.location.href = `/payment?orderId=${res.data.orderId}`
          } else {
            this.$message.error(res.msg || '预约失败，请重试')
          }
        } catch (err) {
          console.error('预约提交失败：', err)
          this.$message.error(err || '预约失败，请重试')
        } finally {
          this.submitLoading = false
        }
      })
    },

    /**
     * 日期格式化工具，将Date对象转换为"YYYY-MM-DD"格式
     */
    formatDate(date) {
      if (!(date instanceof Date)) return ''
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    handleUserDetail() {
      //关闭当前弹窗
      this.handleClose()
      // 跳转到用户详情页
      this.$router.push({
        path: '/personalConsultDetail',
        query: {
          consultant_id: this.form.consultantId
        }
      })
    },

    /**
     * 处理关注用户筛选
     */
    handleFollowFilter(user) {
      this.followDialogVisible = false
      this.$emit('filterByUser', user.id)
    },

    /**
     * 获取关注列表
     */
    async getFollowList() {
      try {
        const res = await getFollowList()
        if (res.code === 1) {
          this.followList = res.data || []
        } else {
          this.$message.error('获取关注列表失败')
        }
      } catch (err) {
        console.error('获取关注列表失败：', err)
        this.$message.error('获取关注列表失败，请重试')
      }
    },

    /**
     * 取消关注
     */
    async handleUnfollow(userId) {
      this.$confirm('确定要取消关注该用户吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          try {
            const res = await unfollowUser(userId)
            if (res.code === 1) {
              this.$message.success('取消关注成功')
              this.getFollowList() // 刷新列表
            } else {
              this.$message.error(res.msg || '取消关注失败')
            }
          } catch (err) {
            console.error('取消关注失败：', err)
            this.$message.error('取消关注失败，请重试')
          }
        })
        .catch(() => {
          // 取消操作
        })
    },

    /**
     * 获取粉丝列表
     */
    async getFanList() {
      try {
        const res = await getFanList()
        if (res.code === 1) {
          this.fanList = res.data || []
        } else {
          this.$message.error('获取粉丝列表失败')
        }
      } catch (err) {
        console.error('获取粉丝列表失败：', err)
        this.$message.error('获取粉丝列表失败，请重试')
      }
    },

    /**
     * 移除粉丝
     */
    async handleRemoveFan(fanId) {
      this.$confirm('确定要移除该粉丝吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          try {
            const res = await removeFan(fanId)
            if (res.code === 1) {
              this.$message.success('移除粉丝成功')
              this.getFanList() // 刷新列表
            } else {
              this.$message.error(res.msg || '移除粉丝失败')
            }
          } catch (err) {
            console.error('移除粉丝失败：', err)
            this.$message.error('移除粉丝失败，请重试')
          }
        })
        .catch(() => {
          // 取消操作
        })
    },

    /**
     * 格式化手机号（中间4位脱敏）
     */
    formatPhone(phone) {
      if (!phone) return '未知用户'
      return phone.replace(/(\d{3})(\d{4})(\d{4})/, '$1****$3')
    },

    /**
     * 重置表单
     */
    resetForm() {
      this.form = {
        ...this.form,
        type: '',
        consultDescription: '',
        date: null,
        time: '',
        duration: '1',
        people: '1',
        price: ''
      }
      this.timeOptions = []
      this.conflictTip = ''
      this.showDescInput = false
      this.loading = false
      this.submitLoading = false
      this.$refs.formRef && this.$refs.formRef.resetFields()
    },

    /**
     * 处理弹窗关闭
     */
    handleClose() {
      this.currentVisible = false
      this.$emit('close')
      this.$emit('update:visible', false)
      this.resetForm()
    },

    /**
     * 弹窗关闭前处理
     */
    handleBeforeClose(done) {
      this.$confirm('确定要取消预约吗？已填写的内容将被清空。')
        .then(() => {
          done()
          this.handleClose()
        })
        .catch(() => {
          // 取消关闭
        })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .custom-dialog {
  border-radius: 12px;
  overflow: hidden;

  .el-dialog__header {
    padding: 24px 40px 20px;
    border-bottom: none;

    .el-dialog__title {
      font-size: 20px;
      font-weight: 600;
      color: #333;
      display: flex;
      align-items: center;
      gap: 8px;

      &::before {
        content: '';
        display: inline-block;
        width: 24px;
        height: 24px;
        background-image: url('/img/yuyue.png');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
      }
    }

    .el-dialog__headerbtn {
      top: 24px;
      right: 40px;
    }
  }

  .el-dialog__body {
    padding: 24px 60px;
  }

  .el-dialog__footer {
    padding: 20px 40px 32px;
    border-top: none;
  }
}

// 弹窗整体样式
.dialog {
  // 用户信息样式
  .user-info {
    display: flex;
    align-items: center;
    height: 50px;
    position: relative;

    .avatar {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      border: 2px solid #acacac;
      margin-right: 10px;
      object-fit: cover;
    }

    .gender-icon {
      width: 18px;
      height: 18px;
      position: relative;
      left: -24px;
      top: -16px;
    }

    .nickname {
      font-weight: 500;
      font-size: 16px;
      margin-left: -8px;
    }
  }

  // 冲突提示样式
  .conflict-tip {
    color: #f56c6c;
    font-size: 12px;
    margin-top: 5px;
    line-height: 1.5;
  }

  // 价格提示样式
  .price-tip {
    color: #606266;
    font-size: 12px;
    margin-top: 5px;
  }

  // 表单样式优化
  ::v-deep .el-form {
    .el-form-item {
      margin-bottom: 24px;

      .el-form-item__label-wrap {
        text-align: left !important;
      }

      .el-form-item__label {
        font-size: 16px;
        color: #333;
        font-weight: 500;
        padding-bottom: 8px;
        text-align: left !important;
        padding-right: 0 !important;

        // 确保星号左对齐，不影响文本对齐
        &::before {
          display: inline;
          margin-right: 4px;
        }
      }

      // 处理必填项星号对齐
      &.is-required {
        left: -13px;
        position: relative;
        .el-form-item__label::before,
        .el-form-item__label-wrap .el-form-item__label::before {
          display: inline;
          margin-right: 4px;
        }
      }
      .time-select {
        left: 1px;
        position: relative;
        top: -5px;
        height: 20px;
      }
      .el-form-item__content {
        .el-select,
        .el-input,
        .el-textarea,
        .el-date-editor {
          width: 100%;
        }
      }
    }
  }
  /deep/ .el-input__prefix {
    height: 20px;
  }
}

// 弹窗底部按钮样式
.dialog-footer {
  text-align: center;
  padding: 0;

  .submit-btn {
    width: 60%;
    height: 48px;
    font-size: 18px;
    font-weight: 500;
    border-radius: 8px;
    background: #5ad3cd;
    border-color: #5ad3cd;

    &:hover {
      background: #4ab8b2;
      border-color: #4ab8b2;
    }
  }
}

// 列表容器样式
.list-container {
  max-height: 400px;
  overflow-y: auto;
  padding-right: 10px;

  .list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid #f5f5f5;

    &:last-child {
      border-bottom: none;
    }

    .delete-btn {
      color: #f56c6c;
    }
  }
}

// 空列表提示
.empty-tip {
  text-align: center;
  padding: 30px 0;
  color: #909399;
}

// 滚动条样式优化
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 3px;
}

::-webkit-scrollbar-track {
  background-color: transparent;
}
/deep/ .el-form-item__content {
  display: flex;
}
.price {
  font-weight: 600;
  font-size: 18px;
  color: #ff724c;
}
</style>
